import { TagFields, tagGQLFields } from '../post/tag.fields.js'

export type HighlightedTagFields = TagFields

export function highlightedTagGQLFields(fields: TagFields): string {
  return `
    ${tagGQLFields(fields)}
  `
}
